<template>
  <div id="app">
    <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav> -->
    <router-view/>
  </div>
</template>
<script>
	export default{
		data(){
			return{
				
			}
		},
		onLaunch: function() {    
		    uni.setLocale('en')  // 简体中文  
		    // uni.setLocale('zh-Hant')  // 繁体中文  
		    // uni.setLocale('en')  // 英文  
		}
	}
</script>
<style>
	@import url("./assets/css/gloabal.css");
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-width: 100%;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
